import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faUser} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../../contexts/auth";
import React, {
  useEffect,
  useState,
} from "react";
import {getUsers, startImpersonate} from "../../../api/administration";
import AccessDenied from "../../../components/access-denied/access-denied";
import LoadPanel from "devextreme-react/load-panel";
import DataGrid, {
  Column, Pager, Paging, SearchPanel, Sorting,
} from "devextreme-react/data-grid";
import notify from "devextreme/ui/notify";
//import ZagolovokFromMenu from "../../../components/zagolovok/zagolovok";
import {canImpersonateTargetUser, getImpersonationBlockedHint, isStaffRoleChecker} from "../../../utils/roleChecker";
import { Button } from "devextreme-react/button";
import { Tooltip } from "devextreme-react/tooltip";
import {generateFingerpint} from "../../../api/auth";
import StorageService from "../../../services/storage.service";
import {FilterRow} from "devextreme-react/tree-list";
import './admin-impersonation.css'
import {getddMMyyyyHHmm} from "../../../utils/date.utils";

const PAGE_SIZES = [10, 25, 50, 100];
const PAGE_SIZE_STORAGE_KEY = 'admin-impersonation-page-size';

const getSavedPageSize = () => {
  const saved = Number(window.localStorage.getItem(PAGE_SIZE_STORAGE_KEY));
  return PAGE_SIZES.includes(saved) ? saved : 10;
};

const ImpersonationBlockedHintIcon = ({ userId, hint }) => {
  const [visible, setVisible] = useState(false);
  const targetId = `impersonate-blocked-${userId}`;

  return (
    <div className="centered-cell">
      <span
        id={targetId}
        className="impersonate-blocked-hint"
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
      >
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <circle cx="9" cy="9" r="8" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <path
            d="M6.75 6.6C6.95 5.35 7.85 4.55 9.15 4.55C10.5 4.55 11.4 5.35 11.4 6.55C11.4 7.5 10.9 8.05 10.1 8.55C9.25 9.05 8.85 9.45 8.85 10.25V10.7H7.55V10.15C7.55 9.15 7.95 8.6 8.8 8.1C9.55 7.65 9.9 7.3 9.9 6.6C9.9 5.95 9.4 5.5 8.7 5.5C7.95 5.5 7.5 5.95 7.35 6.6L6.75 6.6ZM8.2 13.1C8.2 12.55 8.6 12.15 9.15 12.15C9.7 12.15 10.1 12.55 10.1 13.1C10.1 13.65 9.7 14.05 9.15 14.05C8.6 14.05 8.2 13.65 8.2 13.1Z"
            fill="currentColor"
          />
        </svg>
      </span>
      <Tooltip
        target={`#${targetId}`}
        visible={visible}
        hideOnOutsideClick={false}
        position="top"
      >
        <div className="impersonate-blocked-hint-text">{hint}</div>
      </Tooltip>
    </div>
  );
};

const hasValue = (value) =>
  value != null && String(value).trim() !== '' && String(value).trim().toLowerCase() !== 'null';

const getUserDisplayName = (data) => {
  const parts = [data?.last_name, data?.first_name, data?.middle_name].filter(hasValue);
  if (parts.length) return parts.join(' ');
  if (hasValue(data?.mobile_phone)) return data.mobile_phone;
  return data?.id != null ? String(data.id) : '';
};

const getImpersonationDisplay = (data) =>
  hasValue(data?.email) ? data.email : getUserDisplayName(data);

const  AdminImpersonationPage = () => {
  const { user } = useAuth();
  const [visiblePage, setVisiblePage] = useState(true);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState(null);
  const [pageSize, setPageSize] = useState(getSavedPageSize);
  const { syncUserData, setAuth, setCountDogovors, setSelectedDog } = useAuth();

  useEffect(() => {
    if (!user || !isStaffRoleChecker(user)) {
      setVisiblePage(false)
      return
    }
    (async function(){
      setVisiblePage(true)
      setLoading(true)
      const resUsers = await getUsers();
      if (resUsers?.isOk) {
        setUsers(resUsers.data)
      } else if (!resUsers.isOk) {
        notify(resUsers.message, 'error', 5000)
      }
      setLoading(false)
    })()
  }, [user])

  const startImpersonation = async (targetUser) => {
    if (targetUser.id === user.id) {
      notify('Нельзя войти под своим пользователем!', 'error', 5000);
      return;
    }
    if (!canImpersonateTargetUser(targetUser)) {
      notify('Недопустима имперсонация администраторов или сотрудников!', 'error', 5000);
      return;
    }

    const fingerprint = await generateFingerpint()
    const resStart = await startImpersonate(targetUser.id, fingerprint);
    if (resStart.isOk) {
      // Drop stale admin dog before setAuth; dogovors load async in auth.js
      StorageService.removeLocalDodovor()
      setSelectedDog(null)
      StorageService.setLocalAuth(fingerprint)
      setAuth(resStart.res.data)
      setCountDogovors(resStart.res.data.dogovors)
      window.localStorage.setItem("originalUser", JSON.stringify(resStart.res.originalUser))
      notify(`Вы вошли как ${getImpersonationDisplay(targetUser)}`, 'success', 5000);
      await syncUserData()
    } else {
      notify(resStart.message, 'error', 10000);
    }
  }

  const onEnterCellRender = (e) => {
    const targetUser = e.data
    if (targetUser.id === user.id) {
      return null
    }

    if (!canImpersonateTargetUser(targetUser)) {
      return (
        <ImpersonationBlockedHintIcon
          userId={targetUser.id}
          hint={getImpersonationBlockedHint(targetUser)}
        />
      )
    }

    return (
      <Button
        text="Войти"
        stylingMode="text"
        onClick={() => startImpersonation(targetUser)}
      />
    )
  }

  const onlineCellRender = (e) => {
    const data = e.data
    return (
        <div className={'centered-cell'}>
            {data.online ?
                <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="9" cy="9" r="6" fill="#28a745"/>
                </svg>
                :
                <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="9" cy="9" r="6" fill="#ff0000"/>
                </svg>
            }
        </div>
    )
  }
  const dateRender = (e) => {
    const data = e.data
    return (
        <div className={'centered-cell'}>
          {!data.date_last_enter ?
              <>—</>
              :
              <div>{getddMMyyyyHHmm(data.date_last_enter)}</div>
          }
        </div>
    )
  }

  const onGridOptionChanged = (e) => {
    if (e.fullName !== 'paging.pageSize') {
      return
    }
    const nextPageSize = Number(e.value)
    if (!PAGE_SIZES.includes(nextPageSize)) {
      return
    }
    setPageSize(nextPageSize)
    window.localStorage.setItem(PAGE_SIZE_STORAGE_KEY, String(nextPageSize))
  }

  return (
      <>{visiblePage ?
          <div className={'content-block dx-card responsive-paddings'}>
            <FontAwesomeIcon
                className="icon-header-h3 main-color main-color-light"
                icon={faUser}
            />
            <h3>
              <strong>Пользователи ЛК</strong>
            </h3>
            <h5><strong>Подключенные пользователи:</strong></h5>
            <DataGrid
                keyExpr="id"
                allowColumnReordering={true}
                rowAlternationEnabled={true}
                showBorders={true}
                noDataText="Нет подключенных пользователей"
                dataSource={users}
                columnAutoWidth={true}
                wordWrapEnabled={true}
                allowColumnResizing={true}
                onOptionChanged={onGridOptionChanged}
            >
              <Sorting mode="multiple" />
              <FilterRow visible={true} />
              <SearchPanel visible={true} />
              <Column caption="" cellRender={onEnterCellRender} ></Column>
              <Column dataField="online" caption="Онлайн" cellRender={onlineCellRender} />
              <Column dataField="date_last_enter" width={"140"} caption="Последнее посещение" dataType="datetime" format="dd.MM.yyyy HH:mm" cellRender={dateRender} />
              <Column dataField="id" caption="Код в ЛКК" dataType="string" allowEditing={false} />
              <Column dataField="last_name" caption="Фамилия" dataType="string" allowEditing={false} />
              <Column dataField="first_name" caption="Имя" dataType="string" allowEditing={false} />
              <Column dataField="middle_name" caption="Отчество" dataType="string" allowEditing={false} />
              <Column dataField="email" caption="Email" dataType="string" allowEditing={false} />
              <Column dataField="id_asuse" caption="Код в АСУСЭ" dataType="string" allowEditing={false} />
              <Column dataField="inn" caption="ИНН" dataType="string" allowEditing={false} />
              <Column dataField="is_active_phone" caption="Вход по тлф" dataType="boolean" allowEditing={false} />
              <Column dataField="is_active_email" caption="Вход по email" dataType="boolean" allowEditing={false} />
              <Pager allowedPageSizes={PAGE_SIZES} showPageSizeSelector={true} visible={true} />
              <Paging pageSize={pageSize} />
            </DataGrid>
            <LoadPanel visible={loading} />
          </div>
          : <AccessDenied/>}</>
  )
};

export default AdminImpersonationPage;
